// extracted by mini-css-extract-plugin
export var container = "_q7-0";
export var dotAnimation = "_q7-2";
export var dotsLoading = "_q7-1";